import * as Api from '@ViewModels';
import { useQueries } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export const ATTACHMENT_MULTIPLE_QUERY_KEY = 'attachmentMultipleQuery';

export function useMultipleAttachmentsQuery({
	ids,
	enabled,
	impersonationContext,
}: {
	ids: string[];
	enabled: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();

	return useQueries({
		queries: ids.map(id => {
			return {
				enabled,
				queryFn: async () => {
					return userSession.webServiceHelper.callAsync<Api.IFileAttachment>(
						Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: `attachment/${id}` }),
						'GET'
					);
				},
				queryKey: [ATTACHMENT_MULTIPLE_QUERY_KEY, id, impersonationContext],
			};
		}),
	});
}
